<template>

<com-logic>

    <div class="logic-text">In last</div>

    <com-input :type="type" force="numeric" :rule="rule" v-model="model.value" />

    <div class="logic-text" v-if="model.value !== 1">{{ textPlural[rule.setting.period] }}</div>
    <div class="logic-text" v-if="model.value === 1">{{ textSingular[rule.setting.period] }}</div>

</com-logic>

</template>

<script>

import mixLogic from './logic'

export default {

    mixins: [mixLogic],

    data: function() {

        return {
            noOperand: true,
            model: {
                operand: '=',
                value: ''
            },
            textPlural: {
                day: 'days',
                week: 'weeks',
                month: 'months',
                year: 'years',
                decade: 'decades'
            },
            textSingular: {
                day: 'day',
                week: 'weeks',
                month: 'month',
                year: 'year',
                decade: 'decade'
            }
        }

    }

}

</script>

<style scoped>

</style>